import type { MfgPricingLayerBand, MfgPricingLayerGridRow } from "@/lib/manufacturing/types";
import { shelfVariance, type ShelfVarianceTone } from "@/lib/manufacturing/cogsShelfVariance";
import { formatUsd } from "./pricingGridFormat";

export const SHELF_VARIANCE_TONE: Record<ShelfVarianceTone, string> = {
  up: "text-amber-800 dark:text-amber-200",
  down: "text-emerald-800 dark:text-emerald-200",
  flat: "text-gray-500 dark:text-zinc-400",
  missing: "text-gray-400 dark:text-zinc-500",
};

function bandTotal(row: MfgPricingLayerGridRow, band: MfgPricingLayerBand): number {
  if (band === "cogs") return row.cogs_total_usd;
  if (band === "wholesale") return row.wholesale_total_usd;
  return row.msrp_total_usd;
}

export function PricingBandTotalCell({
  band,
  row,
  onOpen,
}: {
  band: MfgPricingLayerBand;
  row: MfgPricingLayerGridRow;
  onOpen?: () => void;
}) {
  const total = bandTotal(row, band);
  const shelf = band === "wholesale" ? row.shelf_wholesale_usd : band === "msrp" ? row.shelf_msrp_usd : null;
  const variance = band === "cogs" ? null : shelfVariance(total, shelf);
  const noteClass = variance ? `text-[10px] font-normal leading-tight ${SHELF_VARIANCE_TONE[variance.tone]}` : "";
  return (
    <div className="text-right">
      <div>{formatUsd(total)}</div>
      {variance && onOpen ? (
        <button type="button" className={`${noteClass} underline decoration-dotted`} title={variance.title} onClick={onOpen}>
          {variance.label}
        </button>
      ) : variance ? (
        <div className={noteClass} title={variance.title}>
          {variance.label}
        </div>
      ) : null}
    </div>
  );
}
